import { Shapes } from 'lucide-react'
import { useCallback, useEffect, useState } from 'react'
import PageHeader from '../components/layout/PageHeader.jsx'
import Card from '../components/ui/Card.jsx'
import DataTable from '../components/ui/DataTable.jsx'
import ErrorState from '../components/ui/ErrorState.jsx'
import LoadingSkeleton from '../components/ui/LoadingSkeleton.jsx'
import RecordStatus from '../components/ui/RecordStatus.jsx'
import { supabase } from '../lib/supabase.js'

export default function CharactersPage() {
  const [characters, setCharacters] = useState([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState('')

  const loadCharacters = useCallback(async () => {
    setIsLoading(true); setError('')
    try {
      const { data, error: queryError } = await supabase
        .from('character')
        .select('character_id, preferred_label, character_type, review_status')
        .order('preferred_label', { ascending: true })
        .limit(75)
      if (queryError) throw queryError
      setCharacters(data || [])
    } catch (queryError) {
      setError(queryError instanceof Error ? queryError.message : 'Characters could not be loaded.')
    } finally { setIsLoading(false) }
  }, [])

  useEffect(() => { loadCharacters() }, [loadCharacters])

  const columns = [
    { key: 'preferred_label', label: 'Character' },
    { key: 'character_type', label: 'Type' },
    { key: 'review_status', label: 'Review', render: (row) => <RecordStatus value={row.review_status} /> },
  ]

  return <><PageHeader eyebrow="Knowledge · Live database" title="Characters" description="Browse botanical character definitions currently installed in Supabase’s botanical schema. Runtime identification use requires separate reviewed interpretations." /><Card className="data-card"><div className="card-heading"><div><h2>Installed character ontology</h2><p>Read-only character records, showing up to 75 in label order.</p></div><span className="panel-icon"><Shapes aria-hidden="true" /></span></div>{isLoading ? <LoadingSkeleton lines={5} /> : error ? <ErrorState message={error} onRetry={loadCharacters} /> : <DataTable caption="Botanical character ontology records" columns={columns} rows={characters} getRowKey={(row) => row.character_id} emptyTitle="No characters yet" emptyDescription="Reviewed character authoring will begin after the pilot ontology is approved." />}</Card></>
}
